var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageRulesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage Rules"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.3335 13.4502H60.0002C61.7683 13.4502 63.464 14.1526 64.7142 15.4028C65.9644 16.6531 66.6668 18.3488 66.6668 20.1169V66.7835C66.6668 68.5516 65.9644 70.2473 64.7142 71.4976C63.464 72.7478 61.7683 73.4502 60.0002 73.4502H20.0002C18.2321 73.4502 16.5364 72.7478 15.2861 71.4976C14.0359 70.2473 13.3335 68.5516 13.3335 66.7835V20.1169C13.3335 18.3488 14.0359 16.6531 15.2861 15.4028C16.5364 14.1526 18.2321 13.4502 20.0002 13.4502H26.6668",
    stroke: "url(#paint0_linear_1219_29501)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.6665 33.4502L56.6665 33.4502",
    stroke: "url(#paint1_linear_1219_29501)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30 30.1172L23.5714 36.7839L20 34.3596",
    stroke: "url(#paint2_linear_1219_29501)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.6667 43.4502L20 50.1169",
    stroke: "url(#paint3_linear_1219_29501)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20 43.4502L26.6667 50.1169",
    stroke: "url(#paint4_linear_1219_29501)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30 56.7842L23.5714 63.4508L20 61.0266",
    stroke: "url(#paint5_linear_1219_29501)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.6665 46.7842L56.6665 46.7842",
    stroke: "url(#paint6_linear_1219_29501)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.6665 60.1172L56.6665 60.1172",
    stroke: "url(#paint7_linear_1219_29501)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M49.9998 6.78418H29.9998C28.1589 6.78418 26.6665 8.27656 26.6665 10.1175V16.7842C26.6665 18.6251 28.1589 20.1175 29.9998 20.1175H49.9998C51.8408 20.1175 53.3332 18.6251 53.3332 16.7842V10.1175C53.3332 8.27656 51.8408 6.78418 49.9998 6.78418Z",
    stroke: "url(#paint8_linear_1219_29501)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1219_29501",
    x1: 13.3335,
    y1: 43.8299,
    x2: 66.6668,
    y2: 43.8299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1219_29501",
    x1: 36.6665,
    y1: 33.9565,
    x2: 56.6665,
    y2: 33.9565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1219_29501",
    x1: 20,
    y1: 33.4927,
    x2: 30,
    y2: 33.4927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1219_29501",
    x1: 20,
    y1: 46.8257,
    x2: 26.6667,
    y2: 46.8257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1219_29501",
    x1: 20,
    y1: 46.8257,
    x2: 26.6667,
    y2: 46.8257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1219_29501",
    x1: 20,
    y1: 60.1597,
    x2: 30,
    y2: 60.1597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1219_29501",
    x1: 36.6665,
    y1: 47.2905,
    x2: 56.6665,
    y2: 47.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1219_29501",
    x1: 36.6665,
    y1: 60.6235,
    x2: 56.6665,
    y2: 60.6235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1219_29501",
    x1: 26.6665,
    y1: 13.5352,
    x2: 53.3332,
    y2: 13.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageRulesActive);
export default __webpack_public_path__ + "static/media/manage-rules-active.034a05d78015086bc6bebb689cbe64b2.svg";
export { ForwardRef as ReactComponent };